module.exports = __webpack_public_path__ + "static/media/shopify-merchant.af62dd72.png";